import { Badge, UncontrolledTooltip } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Swal from "sweetalert2";

export const getCategoryColumns = (columnHelper, openModalForEdit, toggleCategory,role) => [
  columnHelper.accessor("name", {
    header: "Nombre",
    cell: (info) => <strong>{info.getValue()}</strong>,
  }),

  columnHelper.display({
    id: "status",
    header: "Estado",
    cell: (props) => {
      const status = props.row.original.status;
      return (
        <Badge color={status ? "success" : "danger"}>
          {status ? "Activo" : "Inactivo"}
        </Badge>
      );
    },
  }),

  columnHelper.accessor("created_at", {
    header: "Fecha de creación",
    cell: (info) => {
      const raw = info.getValue();
      return raw ? new Date(raw).toLocaleDateString() : "-";
    },
  }),

  columnHelper.display({
    id: "acciones",
    header: "Acciones",
    cell: (props) => {
      const category = props.row.original;
      const isActive = category.status;
      const toggleColor = isActive ? "danger" : "success";
      const toggleIcon = isActive ? "fa fa-toggle-off" : "fa fa-toggle-on";
      const toggleText = isActive ? "Inactivar" : "Activar";

      const editId = `edit-btn-${category.id}`;
      const toggleId = `toggle-btn-${category.id}`;

      const handleToggle = () => {
        Swal.fire({
          title: `¿Quieres ${toggleText.toLowerCase()} esta categoría?`,
          text: `Categoría: ${category.name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: isActive ? "#d33" : "#3085d6",
          cancelButtonColor: "#6c757d",
          confirmButtonText: `Sí, ${toggleText}`,
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await toggleCategory({ id: category.id });
          }
        });
      };

      return (
        <div className="d-flex gap-2">
          <Btn
            attrBtn={{
              color: "primary",
              size: "sm",
              id: editId,
              onClick: () => openModalForEdit(category),
              disabled: role === "ASSISTANT",
            }}
          >
            <i className="fa fa-edit"></i>
          </Btn>
          <UncontrolledTooltip placement="top" target={editId}>
            Editar
          </UncontrolledTooltip>

          <Btn
            attrBtn={{
              color: toggleColor,
              size: "sm",
              id: toggleId,
              onClick: handleToggle,
              disabled: role === "ASSISTANT",
            }}
          >
            <i className={toggleIcon}></i>
          </Btn>
          <UncontrolledTooltip placement="top" target={toggleId}>
            {toggleText}
          </UncontrolledTooltip>
        </div>
      );
    },
  }),
];
